// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const AtSymbolIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-hidden": "true",
  "data-icon": "AtSymbol/solid"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M14.243 5.757a6 6 0 1 0-.986 9.284 1 1 0 1 1 1.087 1.678A8 8 0 1 1 18 10a3 3 0 0 1-4.8 2.401A4 4 0 1 1 14 10a1 1 0 1 0 2 0c0-1.537-.585-3.07-1.757-4.243ZM12 10a2 2 0 1 0-4 0 2 2 0 0 0 4 0Z",
  clipRule: "evenodd"
}));
export default AtSymbolIcon;